// Get version from package.json or environment
const getAppVersion = () => {
  try {
    return require('../../package.json').version;
  } catch (error) {
    return '1.0.0'; // fallback version
  }
};

export const KEWA_CONFIG = {
  baseUrl: process.env.REACT_APP_KEWA_BASE_URL,
  projectId: process.env.REACT_APP_KEWA_PROJECT_ID,
  appCode: 'EPR005',
  appVersion: getAppVersion(),
  environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
  enabled: true, // Set to false to disable tracking
  customPageviewTracking:true, // Enable custom pageview tracking
};

export const KEWA_EVENTS = {
  // Page Events
  PAGE_VIEW: 'route_view',
  NAVIGATION: 'navigation',

  // User Events
  USER_LOGIN: 'user_login',
  USER_LOGOUT: 'user_logout',
  USER_REGISTER: 'user_register',

  // Interaction Events
  BUTTON_CLICK: 'button_click',
  FORM_SUBMIT: 'form_submit',
  FORM_ERROR: 'form_error',

  // Business Events
  DOWNLOAD: 'download',
  UPLOAD: 'upload',
  REPORT_GENERATE: 'report_generate',
  REPORT_DOWNLOAD: 'report_download',
  INVOICE_CREATE: 'invoice_create',
  PAYMENT_PROCESS: 'payment_process',
  WORK_ORDER_CREATE: 'work_order_create',

  // System Events
  ERROR: 'error',
  API_ERROR: 'api_error',
  PERFORMANCE: 'performance',

  BRAND_WORK_ORDER_SAVE_AS_DRAFT_BUTTON: 'brand_work_order_button_save_as_draft',
  VENDOR_WORK_ORDER_SAVE_AS_DRAFT_BUTTON: 'vendor_work_order_button_save_as_draft',
  VENDOR_WORK_ORDER_SAVE_BUTTON: 'vendor_work_order_button_save',

  BRAND_FULFILLMENT_ADVANCED_FILTERS_APPLY: 'brand_fulfillment_advanced_filters_applied',
  BRAND_FULFILLMENT_ADVANCED_FILTERS_CLEAR: 'brand_fulfilment_advanced_filters_cleared',
  VENDOR_FULFILLMENT_ADVANCED_FILTERS_APPLY: 'vendor_fulfillment_advanced_filters_apply',
  VENDOR_FULFILLMENT_ADVANCED_FILTERS_CLEAR: 'vendor_fulfillment_advanced_filters_clear',
  CREATE_BRAND_WORK_ORDER_BUTTON_CLICK: 'create_brand_work_order_button_click',
  BRAND_WORK_ORDER_FILTER_CHANGE: 'brand_work_order_filter_change',
  CREATE_VENDOR_WORK_ORDER_BUTTON_CLICK: 'create_vendor_work_order_button_click',
  PLANNING_TAB_CHANGED: 'planning_tab_changed',
  REPLAN_BUTTON_CLICK: 'planning_replan_button_click',
  PLAN_BUTTON_CLICK: 'planning_plan_button_click',
  VIEW_EDIT_BUTTON_CLICK: 'planning_view_edit_button_click',
};
